import { GraphQLError } from "@alaffia-technology-solutions/schema";

type Handler = (message: string, data: { description: string }) => void;

export const handleError = (error: unknown, handler: Handler) => {
  const parsedError = GraphQLError.safeParse(error);

  const description = parsedError.success
    ? parsedError.data.message
    : "Unknown error";

  handler("Something went wrong", {
    description,
  });
};
